import { BaseResponseMapper } from './Base'
import { Pagination } from '@/domain/entities/Pagination'
import {
  TrainingCategory,
  TrainingCategoryData,
} from '@/domain/entities/TrainingCategory'
import { AxiosResponse } from 'axios'

export class TrainingCategoryDataMapper extends BaseResponseMapper {
  public convertFromApi(result: AxiosResponse<any>): TrainingCategory {
    const { data } = result
    return new TrainingCategory(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new TrainingCategoryData(
            val.id,
            val.name,
            val.tag,
            val.total_training_files,
            val.training_active,
            val.image_thumbnail,
            val.image_cover,
            val.image_logo,
            val.created_at,
            val.updated_at
          )
      )
    )
  }
}
